import { Button, ButtonProps, Icon } from '@chakra-ui/react';
import { ReactComponent as GlobeIcon } from 'assets_2/icons/earth-outline-home.svg';
import React from 'react';
import { HiChevronDown } from 'react-icons/hi';

export type LanguageSelectorVariant = 'light' | 'dark';

interface SelectorButtonProps extends ButtonProps {
  selectedLanguage?: string;
  variant?: LanguageSelectorVariant;
}

// Outlined, white-on-dark style used by FooterFlux.
const darkStyles: ButtonProps = {
  height: '40px',
  px: 4,
  fontSize: '16px',
  color: 'primary.white',
  border: '1px solid',
  borderColor: 'secondary.darkGrey',
  borderRadius: '8px',
  sx: { '& svg': { filter: 'brightness(0) invert(1)' } },
  _hover: { backgroundColor: 'secondary.darkGrey', color: 'primary.white' },
  _active: { backgroundColor: 'secondary.darkGrey' }
};

// eslint-disable-next-line react/display-name
const SelectorButton: React.FC<SelectorButtonProps> = React.forwardRef<
  HTMLButtonElement,
  SelectorButtonProps
>((props, ref) => {
  const { selectedLanguage, variant = 'light', ...otherProps } = props;
  const isDark = variant === 'dark';
  return (
    <Button
      fontFamily="ProximaNova"
      fontSize="18px"
      fontWeight="600"
      fontStretch="normal"
      fontStyle="normal"
      lineHeight="23px"
      letterSpacing="0.22px"
      color="black"
      transition="0.4s"
      height="30px"
      background="transparent"
      _focus={{
        outline: 'none'
      }}
      _disabled={{
        opacity: 0.5,
        background: 'white',
        color: 'black'
      }}
      ref={ref}
      {...(isDark ? darkStyles : {})}
      {...otherProps}
    >
      <Icon
        as={GlobeIcon}
        width={isDark ? '20px' : '15px'}
        height={isDark ? '20px' : '15px'}
        marginRight={isDark ? '4px' : '5px'}
      />
      {selectedLanguage}
      <Icon
        as={HiChevronDown as React.ElementType}
        boxSize="20px"
        marginLeft="4px"
      />
    </Button>
  );
});

export default SelectorButton;
